module.exports = "/_next/static/images/new-badge-136fb77cc8bebbd69eac580eb45f8bbf.svg";